import { useEffect, useState } from "react";

export default function Nav({ onCta }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-black/70 border-b border-neutral-900"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
          aria-label="Big Stick Energy home"
        >
          <img
            src="/logo/monogram.png"
            alt="BSE"
            className="h-9 md:h-10 w-auto select-none"
            draggable={false}
          />
          <span className="hidden sm:inline font-anton text-sm tracking-[0.18em] uppercase text-neutral-300 group-hover:text-white transition-colors">
            Big Stick Energy
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10 text-[11px] font-bold tracking-[0.2em] uppercase text-neutral-400">
          <a
            href="#gear"
            className="hover:text-white transition-colors"
            data-testid="nav-link-gear"
          >
            Gear
          </a>
          <a
            href="#marks"
            className="hover:text-white transition-colors"
            data-testid="nav-link-marks"
          >
            Marks
          </a>
          <a
            href="#stickers"
            className="hover:text-white transition-colors"
            data-testid="nav-link-stickers"
          >
            Stickers
          </a>
          <a
            href="#manifesto"
            className="hover:text-white transition-colors"
            data-testid="nav-link-manifesto"
          >
            Manifesto
          </a>
          <a
            href="#schedule"
            className="hover:text-white transition-colors"
            data-testid="nav-link-schedule"
          >
            Schedule
          </a>
        </nav>

        <button
          onClick={onCta}
          data-testid="nav-pre-order-btn"
          className="group inline-flex items-center gap-2 bg-[#e11d2a] hover:bg-[#ff3340] text-white font-bold uppercase tracking-wide text-xs px-4 py-2.5 transition-colors"
        >
          Pre-Order
          <span className="inline-block group-hover:translate-x-0.5 transition-transform">
            →
          </span>
        </button>
      </div>
    </header>
  );
}
